import React from 'react';
import { FormLabel, TextField, FormHelperText } from '@mui/material';
import { useFormikContext } from 'formik';
import { CLIENT_TYPE, DOMESTIC, OTHER_INFO } from '../validationSchema';

export const BusinessDescription = ({ loading }) => {
	const { values, getFieldProps } = useFormikContext();
	return (
		<>
			<FormLabel>{`Description of ${
				values[CLIENT_TYPE] === DOMESTIC ? '' : 'Business '
			}Activities`}</FormLabel>
			<TextField
				fullWidth
				name={OTHER_INFO}
				multiline
				rows={4}
				{...getFieldProps(OTHER_INFO)}
				disabled={loading}
			/>
			<FormHelperText>
				Provide a brief description of the activities this client conducts.
			</FormHelperText>
		</>
	);
};
